import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Table,
    Button,
    Form,
    FormGroup,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { FaPencilAlt, FaTrash, FaPlus } from 'react-icons/fa';
import { apiURL1 } from '../../config';
import Footer from 'components/Footers/Footer';


const LeaveTypes = () => {
    const token = localStorage.getItem("token");

    const [leaveTypes, setLeaveTypes] = useState([]);
    const [newLeaveTypeName, setNewLeaveTypeName] = useState('');
    const [editLeaveTypeId, setEditLeaveTypeId] = useState(null);
    const [editLeaveTypeName, setEditLeaveTypeName] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    useEffect(() => {
        fetchLeaveTypes();
    }, []);

    const fetchLeaveTypes = async () => {
        try {
            const response = await fetch(`${apiURL1}/superadmin/leave/types`, {
                method: 'GET', // or any other HTTP method as needed
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers
                    // Any other headers can go here
                },
            });;
            const data = await response.json();
            setLeaveTypes(data);
        } catch (error) {
            console.error('Error fetching leave types:', error);
            toast.error('Error fetching leave types!');
        }
    };

    const handleAddLeaveType = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL1}/superadmin/leave/types`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`, // Add token to headers

                },
                body: JSON.stringify({ name: newLeaveTypeName }),
            });
            if (response.ok) {
                toast.success('Leave type added successfully!');
                fetchLeaveTypes();
                setNewLeaveTypeName('');
                setModalOpen(false);
            } else {
                toast.error('Error adding leave type!');
            }
        } catch (error) {
            console.error('Error adding leave type:', error);
            toast.error('Error adding leave type!');
        }
    };

    const handleEditLeaveType = (leaveType) => {
        setEditLeaveTypeId(leaveType._id);
        setEditLeaveTypeName(leaveType.name);
        setEditModalOpen(true);
    };

    const handleUpdateLeaveType = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL1}/superadmin/leave/types/${editLeaveTypeId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`, // Add token to headers

                },
                body: JSON.stringify({ name: editLeaveTypeName }),
            });
            if (response.ok) {
                toast.success('Leave type updated successfully!');
                fetchLeaveTypes();
                setEditLeaveTypeId(null);
                setEditLeaveTypeName('');
                setEditModalOpen(false);
            } else {
                toast.error('Error updating leave type!');
            }
        } catch (error) {
            console.error('Error updating leave type:', error);
            toast.error('Error updating leave type!');
        }
    };

    const handleDeleteLeaveType = async (id) => {
        try {
            const response = await fetch(`${apiURL1}/superadmin/leave/types/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers
                    // Any other headers can go here
                },
            });
            if (response.ok) {
                toast.success('Leave type deleted successfully!');
                fetchLeaveTypes();
            } else {
                toast.error('Error deleting leave type!');
            }
        } catch (error) {
            console.error('Error deleting leave type:', error);
            toast.error('Error deleting leave type!');
        }
    };

    const filteredLeaveTypes = leaveTypes ? leaveTypes.filter((leaveType) =>
        leaveType.name.toLowerCase().includes(searchQuery.toLowerCase())
    ) : [];

    return (
        <>
            <div
                className="header   d-flex align-items-center"
                style={{
                    minHeight: "600px",
                    backgroundImage:
                        "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                }}
            >
                <span className="mask bg-gradient-default opacity-8" />
                <Container className="d-flex align-items-center" fluid>
                    <Row>
                        <Col lg="7" md="10">
                            <h1 className="display-4 text-white">Leave Types</h1>
                            <p className="text-white mt-0 mb-5">
                                Manage leave types for your organization.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">Leave Types</h3>
                                <div>
                                    <Input
                                        type="text"
                                        placeholder="Search leave types..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ marginRight: '10px', display: 'inline-block', width: '200px' }}
                                    />
                                    <Button color="primary" size="sm" onClick={() => setModalOpen(true)}>
                                        <FaPlus /> Add New
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Name</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredLeaveTypes && filteredLeaveTypes.length > 0 ? (
                                            filteredLeaveTypes.map((leaveType) => (
                                                <tr key={leaveType._id}>
                                                    <td>{leaveType.name}</td>
                                                    <td>
                                                        <>
                                                            <Button
                                                                color="info"
                                                                size="sm"
                                                                onClick={() => handleEditLeaveType(leaveType)}
                                                            >
                                                                <FaPencilAlt />
                                                            </Button>
                                                            <Button
                                                                color="danger"
                                                                size="sm"
                                                                onClick={() => handleDeleteLeaveType(leaveType._id)}
                                                            >
                                                                <FaTrash />
                                                            </Button>
                                                        </>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2">No leave types found.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
                <ModalHeader toggle={() => setModalOpen(false)}>Add New Leave Type</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleAddLeaveType}>
                        <FormGroup>
                            <Input
                                type="text"
                                placeholder="Enter leave type name"
                                value={newLeaveTypeName}
                                onChange={(e) => setNewLeaveTypeName(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Add Leave Type
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(false)}>
                <ModalHeader toggle={() => setEditModalOpen(false)}>Edit Leave Type</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleUpdateLeaveType}>
                        <FormGroup>
                            <Input
                                type="text"
                                placeholder="Enter leave type name"
                                value={editLeaveTypeName}
                                onChange={(e) => setEditLeaveTypeName(e.target.value)}
                            />
                        </FormGroup>
                        <Button color="primary" type="submit">
                            Update Leave Type
                        </Button>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                        Cancel
                    </Button>
                </ModalFooter>
                
            </Modal>
             <Footer />
        </>
    );
};

export default LeaveTypes;
